import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core";
import { getDateLabel } from "utils/dates";

import Table from "components/Table";

const tableColumns = [
  { id: "practice", label: "Practice", style: { width: "25%" } },
  { id: "requestedByName", label: "Contact", style: { width: "25%" } },
  { id: "requestedByEmail", label: "Email", style: { width: "25%" } },
  { id: "requestDate", label: "Requested", style: { width: "15%" } },
  { id: "status", label: "Access Status", style: { width: "35%" } },
];

const withFormattedProps = ({
  accessAllowed,
  createdAt,
  status,
  ...access
}) => {
  return {
    ...access,
    practice: accessAllowed.name,
    requestDate: getDateLabel(createdAt),
    status: (
      <span
        style={{
          color: status === "Requested" ? "#2185D0" : "inherit",
        }}
      >
        {status}
      </span>
    ),
  };
};

const useStyles = makeStyles({
  table: {
    border: "1px solid #DADADA",
    borderRadius: "4px",
  },
  headerCell: {
    backgroundColor: "#F9F9F9",
    fontSize: "14px",
    fontWeight: "bold",
    padding: "0.92857143em 0.78571429em",
  },
  bodyCell: {
    fontSize: "14px",
    padding: "0.78571429em 0.78571429em",
  },
});

export function AccessListTable({
  pageControl,
  updatePageControl,
  totalCount,
  loading,
  accessList,
  onSelectRow,
  onSelectAll,
  checkSelected,
  selected,
}) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Table className={classes.table} data-test="access-list-table">
        <Table.Content>
          <Table.Header
            columns={tableColumns}
            className={classes.headerCell}
            onSelectAll={onSelectAll}
            selectedCount={selected.length}
            rowCount={accessList.length}
          />
          <Table.Body
            isLoading={loading}
            columns={tableColumns}
            data={accessList?.map(withFormattedProps) || []}
            className={classes.bodyCell}
            emptyDataMessage="There are no customers with access"
            onRowClick={onSelectRow}
            checkSelected={checkSelected}
          />
        </Table.Content>
      </Table>
      <Table.PaginationControl
        isLoading={loading}
        totalCount={totalCount}
        page={pageControl.page}
        pageSize={pageControl.pageSize}
        onPageChange={updatePageControl}
        onPageSizeChange={updatePageControl}
      />
    </React.Fragment>
  );
}

AccessListTable.propTypes = {
  pageControl: PropTypes.shape({
    page: PropTypes.number,
    pageSize: PropTypes.number,
  }).isRequired,
  updatePageControl: PropTypes.func.isRequired,
  totalCount: PropTypes.number,
  loading: PropTypes.bool,
  accessList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      accessAllowed: PropTypes.shape({
        name: PropTypes.string,
      }),
      requiredByName: PropTypes.string,
      requiredByEmail: PropTypes.string,
      status: PropTypes.string,
      createdAt: PropTypes.instanceOf(Date),
    })
  ),
  checkSelected: PropTypes.func.isRequired,
  onSelectRow: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  selected: PropTypes.array.isRequired,
};

AccessListTable.defaultProps = {
  loading: false,
  totalCount: 0,
  accessList: [],
};

export default AccessListTable;
